module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Stealing His Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Bru Baker")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Connoll Pack")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Love sneaks in like a thief in the night.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Danny’s parents raised him to believe his wolf was a curse. He’s part of the wealthy and powerful Connoll Pack, but only nominally. He abandoned that world to volunteer with supernatural kids, and he isn’t looking for a mate….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max is a shifter who is also a detective. He’s working a case that could make or break his career. Danny’s caught up in the case he’s on, and he’s also irresistible. They’re a bad match—Max, an Alpha having trouble with his new powers, and Danny, who trusts Alphas as far as he could throw one. But they can’t get enough of each other, and they might bond before they even see it coming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They could be amazing together, but they have to get past a few obstacles—especially since someone close to Danny might be involved in the thefts Max is investigating.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0